(function () {
    function clearBasketViewBeforeReload(basket) {
        basket.sortedItems = [];
        basket.shownItems = [];
        basket.items = {};

        if (typeof basket.editTotal === 'function') {
            basket.editTotal();
        }

        const basketItemNodes = document.querySelectorAll('[data-entity="basket-item"]');

        basketItemNodes.forEach(function (node) {
            node.remove();
        });

        const countNode = document.querySelector('[data-entity="basket-items-count"][data-filter="all"]');

        if (countNode) {
            countNode.textContent = '';
        }

        const vatNode = document.querySelector('.basket__checkout-block-vat-value');

        if (vatNode) {
            vatNode.textContent = '';
        }

        const totalPriceNodes = document.querySelectorAll('[data-entity="basket-total-price"]');

        totalPriceNodes.forEach(function (node) {
            node.textContent = '';
        });
    }

    function clearBasket() {
        const basket = window.BX && window.BX.Sale && window.BX.Sale.BasketComponent;

        if (!basket || !basket.items || !basket.actionPool) {
            return;
        }

        const itemIds = Object.keys(basket.items);

        if (!itemIds.length) {
            return;
        }

        itemIds.forEach(function (itemId) {
            if (basket.items[itemId]) {
                basket.actionPool.deleteItem(itemId);
            }
        });

        clearBasketViewBeforeReload(basket);

        basket.actionPool.trySendPool();

        setTimeout(function () {
            window.location.reload();
        }, 700);
    }

    document.addEventListener('click', function (event) {
        const button = event.target.closest('#basket__button-clear');

        if (!button) {
            return;
        }

        event.preventDefault();
        clearBasket();
    });
})();
